export const en = {
    account: 'Account',
    'add-tag-error': 'Couldn\'t add tag',
    address: 'Address',
    all: 'All',
    'all-pages': 'All pages',
    appearance: 'Appearance',
    'appearance-section': 'Customize the interface design to make working comfortable',
    cancel: 'Cancel',
    'created-and-edited': 'Created and edited',
    'created-and-edited-column-author': 'Author',
    'created-and-edited-column-created-at': 'Created At',
    'created-and-edited-column-modified-at': 'Updated',
    'created-and-edited-column-name': 'Page name',
    'created-and-edited-column-slug': 'Path',
    'created-and-edited-empty-result': 'No results were found for the query',
    'created-and-edited-error': 'Error loading data',
    'created-and-edited-filter-all': 'Show all',
    'created-and-edited-filter-creator': 'I\'m an author',
    'created-and-edited-filter-editor': 'I\'m an editor',
    'created-and-edited-filter-error': 'Couldn\'t perform search',
    'created-and-edited-hint': 'Pages that you created or edited.',
    'created-and-edited-no-data': 'The pages that you create or edit appear here. \nThere are no such pages yet.',
    'created-and-edited-personal-cluster': 'Go to personal page',
    delete: 'Delete',
    'delete-page-without-recover': 'The page will be permanently deleted',
    'delete-perm': 'Delete permanently',
    'delete-perm-quest': 'Delete the page permanently?',
    deleted: 'Deleted',
    'deleted-by-me': 'Deleted by me',
    documentation: 'Documentation',
    'documentation-create-page': 'How to create a page',
    'documentation-dynamic-blocks': 'Dynamic blocks',
    'documentation-edit-text': 'How to edit text',
    'documentation-getting-started': 'Getting started',
    'documentation-go-to': 'Go to documentation',
    'documentation-markup-reference': 'Markup reference',
    'empty-description': 'Couldn\'t fetch the settings. Try again.',
    'empty-title': 'An error occurred',
    'favorite-no-data': 'The pages that you add to your favorites appear here. \nThere are no such pages yet.',
    'favorite-pages': 'Favorite pages',
    'favorite-pages-hint': 'Add pages to favorites so you don\'t lose them. Filter your favorite pages by tags.',
    'favorites-add-item': 'Add to favorites',
    'favorites-add-tag-error': 'Couldn\'t add tag',
    'favorites-column-author': 'Author',
    'favorites-column-created-at': 'Created At',
    'favorites-column-modified-at': 'Updated',
    'favorites-column-slug': 'Path',
    'favorites-column-tags': 'Tags',
    'favorites-column-title': 'Page name',
    'favorites-create-error': 'Couldn\'t add page to favorites',
    'favorites-create-tag-error': 'Couldn\'t add tag',
    'favorites-delete-error': 'Couldn\'t delete page from favorites',
    'favorites-delete-item': 'Remove from favorites',
    'favorites-filter-error': 'Couldn\'t perform search',
    'favorites-load-error': 'Couldn\'t load page list',
    'favorites-load-tags-error': 'Couldn\'t load tags',
    'favorites-no-data-for-query': 'No results were found for the query',
    'favorites-table-settings-error': 'Couldn\'t save settings. Some data may be lost.',
    'favorites-tags-error': 'Couldn\'t load tag',
    'favorites-tags-label': 'Tags',
    'favorites-update-error': 'Couldn\'t update favorites',
    'feature-data-ui-web': 'New interface',
    'feature-is-processing-description': 'The page list will be displayed after syncing. Try again in a few minutes.',
    'feature-is-processing-title': 'Transferring data',
    'feature-wysiwyg-editor': 'New default editor',
    featured: 'Important information',
    'featured-error': 'Couldn\'t load data',
    'featured-hint': 'Useful information about the company\'s rules and procedures.',
    features: 'Experiments',
    'features-section': 'Take part in our experiments',
    feedback: 'Feedback',
    'feedback-bug-report': 'Report an error',
    'feedback-suggest-improvement': 'Suggest an improvement',
    'history-of-changes': 'History of changes',
    'interface-theme': 'Interface theme',
    invite: 'Add user',
    language: 'Interface language',
    'language-and-region': 'Language and region',
    'language-and-region-section': 'Select the user interface language',
    'language-english': 'English',
    'language-russian': 'Русский',
    locked: 'Locked',
    'menu-item-create-page': 'Create a page',
    'menu-item-created-and-edited': 'Created and edited',
    'menu-item-favorites': 'Favorites',
    'menu-item-featured': 'Important information',
    'menu-item-personal-cluster': 'My page',
    'menu-item-subscriptions': 'Subscriptions',
    'my-pages': 'My pages',
    notifications: 'Notifications',
    'open-page': 'Open a page',
    page: 'Page',
    'page-deleted': 'Page is deleted',
    'page-restored': 'Page restored',
    'recently-deleted': 'Recently deleted',
    recover: 'Recover',
    'recovery-tokens-no-data-message': 'Your deleted Wiki pages will be stored here. You don’t have any yet.',
    'remove-pages': 'Recently deleted',
    search: 'Search',
    'search-not-found-description': 'No results for "{{query}}". Try rewording your query.',
    'search-not-found-title': 'No results',
    'search-placeholder': 'Search in Wiki pages [{{key}}+s]',
    'settings-get-error': 'Couldn\'t get settings',
    'settings-propose-translation': 'Suggest translation',
    'settings-propose-translation-dont-propose': 'No',
    'settings-propose-translation-propose': 'Yes',
    'settings-update-error': 'Couldn\'t save settings',
    'settings-update-error-description': 'An error occurred. The settings may not be saved.',
    subscriptions: 'Subscriptions',
    'subscriptions-column-author': 'Author',
    'subscriptions-column-created-at': 'Created At',
    'subscriptions-column-modified-at': 'Updated',
    'subscriptions-column-name': 'Section or page name',
    'subscriptions-column-slug': 'Path',
    'subscriptions-create-error': 'Couldn\'t add subscription',
    'subscriptions-create-success': 'Subscription added',
    'subscriptions-delete-error': 'Couldn\'t delete subscription',
    'subscriptions-delete-success': 'Subscription deleted',
    'subscriptions-empty-result': 'No results were found for the query',
    'subscriptions-error': 'Couldn\'t load page list',
    'subscriptions-filter-all': 'Show all',
    'subscriptions-filter-error': 'Couldn\'t perform search',
    'subscriptions-filter-my': 'My subscriptions',
    'subscriptions-filter-other': 'I was subscribed to',
    'subscriptions-hint': 'Pages that you subscribed to or other users subscribed you to.',
    'subscriptions-no-data': 'The pages that you subscribe to appear here. There are no such pages yet.',
    'subscriptions-subscribe': 'Subscribe',
    'subscriptions-unsubscribe': 'Unsubscribe',
    'tabs-search-by-name': 'Search by name',
    'theme-contrast': 'Contrast',
    'theme-contrast-high': 'High (beta)',
    'theme-contrast-normal': 'Standard',
    'theme-dark': 'Dark',
    'theme-light': 'Light',
    'theme-system': 'System'
};
